// eslint-disable-next-line @typescript-eslint/no-namespace
namespace Training {
    export const NAV_SELECTED_CLASS = 'active'
    export const ACCORDION_NAME = 'training-program'
    export const VARS: { [key: string]: any } = {}
    export class TrainingProgram extends HTMLElement {
        constructor() {
            super()
            Training.VARS.currentActive = ''
        }

        resetNav(navEntries: NodeList) {
            navEntries?.forEach(button => {
                ;(button as HTMLButtonElement).classList.remove(Training.NAV_SELECTED_CLASS)
            })
        }

        onNavClicked(btn: HTMLButtonElement, navEntries: NodeList) {
            this.resetNav(navEntries)
            try {
                btn.classList.add(Training.NAV_SELECTED_CLASS)
                Training.VARS.currentActive = `${btn.dataset.name}`
                this.activateAccordionItem()
            } catch (e: unknown) {
                console.log('error while targing button: ', e)
            }
        }

        getMainAccordion(): FeoAccordion | undefined {
            return this.querySelector(`feo-accordion[data-name="${Training.ACCORDION_NAME}"]`) as FeoAccordion
        }

        activateAccordionItem() {
            const accordion: FeoAccordion | undefined = this.getMainAccordion()
            const accordionItems: NodeListOf<FeoAccordionItem> | undefined =
                accordion?.querySelectorAll(`:scope > feo-accordion-item`)

            accordionItems?.forEach(item => {
                item.dataset.name === Training.VARS.currentActive
                    ? item.classList.add(Training.NAV_SELECTED_CLASS)
                    : item.classList.remove(Training.NAV_SELECTED_CLASS)
            })

            // Notify feo accordion
            accordion?.openItem(Training.VARS.currentActive)
        }

        onResize() {
            setTimeout(() => {
                if (window.innerWidth >= 1024) {
                    this.activateAccordionItem()
                }
            }, 100)
        }

        updateCurrentActive(name: string, navEntries: NodeListOf<Element> | undefined) {
            Training.VARS.currentActive = name
            navEntries?.forEach(button => {
                if ((button as HTMLButtonElement).dataset.name === name) {
                    this.resetNav(navEntries)
                    button.classList.add(Training.NAV_SELECTED_CLASS)
                }
            })
        }

        init() {
            const { hash } = window.location
            const navEntries = this.querySelectorAll('.nav-items button')
            navEntries.forEach(button => {
                button.addEventListener('click', evt => {
                    this.onNavClicked(evt.target as HTMLButtonElement, navEntries)
                })
            })
            // Handle default opened
            const defaultOpenedItem = Array.from(navEntries).find(button => {
                return (button as HTMLButtonElement).dataset.anchor === hash
            })
            const defaultOpened = defaultOpenedItem || (navEntries[0] as HTMLButtonElement)

            this.getMainAccordion()?.addEventListener('onOpenStateChanged', (evt: any) => {
                console.log('training program: ', evt)
                if (evt && evt.detail?.name) {
                    this.updateCurrentActive(`${evt.detail?.name}`, navEntries)
                }
            })
            this.onNavClicked(defaultOpened as HTMLButtonElement, navEntries)
            window.addEventListener('resize', this.onResize.bind(this))
        }

        // Scroll into view if we have competence_N hash
        onBodyLoaded() {
            const { hash } = window.location
            if (!hash) {
                return
            }
            try {
                const id = hash.split('_')[1]
                const target = this.querySelector(
                    `feo-accordion-item[data-name="training-program_${parseInt(id, 10) - 1}"]`
                )

                target?.scrollIntoView({
                    behavior: 'smooth'
                })
            } catch (e: unknown) {
                console.log('error: ', e)
            }
        }

        connectedCallback() {
            setTimeout(() => {
                this.init()
            }, 250)

            window.addEventListener('DOMContentLoaded', this.onBodyLoaded.bind(this))
        }
    }
}

!customElements.get('feo-training-program') && customElements.define('feo-training-program', Training.TrainingProgram)
